export const testWeatherArr = {
  forecast: {
    forecastday: [
      {
        date: '2023-11-21',
        date_epoch: 1701129600,
        day: {
          maxtemp_c: 10.3,
          condition: {
            text: 'Moderate rain',
            icon: '//cdn.weatherapi.com/weather/64x64/day/266.png',
            code: 1189,
          }
        },
        astro: {
          sunrise: '07:36 AM',
          sunset: '04:43 PM',
        },
      },
      {
        date: '2023-11-22',
        date_epoch: 1701129601,
        day: {
          maxtemp_c: 4.8,
          condition: {
            text: 'Moderate or heavy sleet',
            icon: '//cdn.weatherapi.com/weather/64x64/day/320.png',
            code: 1189,
          }
        },
        astro: {
          sunrise: '07:12 AM',
          sunset: '04:16 PM',
        },
      },
      {
        date: '2023-11-23',
        date_epoch: 1701129602,
        day: {
          maxtemp_c: -3.8,
          condition: {
            text: 'Patchy moderate snow',
            icon: '//cdn.weatherapi.com/weather/64x64/day/332.png',
            code: 1189,
          }
        },
        astro: {
          sunrise: '07:26 AM',
          sunset: '04:43 PM',
        },
      },
      {
        date: '2023-11-24',
        date_epoch: 1701129603,
        day: {
          maxtemp_c: 4.1,
          condition: {
            text: 'Patchy rain possible',
            icon: '//cdn.weatherapi.com/weather/64x64/day/179.png',
            code: 1189,
          }
        },
        astro: {
          sunrise: '06:36 AM',
          sunset: '07:13 PM',
        },
      },
      {
        date: '2023-11-25',
        date_epoch: 1701129604,
        day: {
          maxtemp_c: 11.3,
          condition: {
            text: 'Partly cloudy',
            icon: '//cdn.weatherapi.com/weather/64x64/day/113.png',
            code: 1189,
          }
        },
        astro: {
          sunrise: '07:46 AM',
          sunset: '05:13 PM',
        },
      },
      {
        date: '2023-11-26',
        date_epoch: 1701129605,
        day: {
          maxtemp_c: 3.1,
          condition: {
            text: 'Cloudy',
            icon: '//cdn.weatherapi.com/weather/64x64/day/119.png',
            code: 1189,
          }
        },
        astro: {
          sunrise: '09:12 AM',
          sunset: '06:15 PM',
        },
      },
      {
        date: '2023-11-27',
        date_epoch: 1701129606,
        day: {
          maxtemp_c: 5.7,
          condition: {
            text: 'Freezing fog',
            icon: '//cdn.weatherapi.com/weather/64x64/day/260.png',
            code: 1189,
          }
        },
        astro: {
          sunrise: '08:36 AM',
          sunset: '05:44 PM',
        },
      },
    ]
  },
};
